import React, { useEffect, useState, useContext, useRef, useImperativeHandle } from "react";
import { Link, useLocation } from "react-router-dom";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";

import api from "services/api";

import { Card } from "@mui/material";
import Grid from "@mui/material/Grid";

import Tooltip from "@mui/material/Tooltip";
import Pagination from "@mui/material/Pagination";

import SuiBadge from "components/SuiBadge";
import SuiTypography from "components/SuiTypography";
import SuiBadgeDot from "components/SuiBadgeDot";
import SuiBox from "components/SuiBox";
import SuiAvatar from "components/SuiAvatar";
import SuiSelect from "components/SuiSelect";
import SuiInput from "components/SuiInput";
import SuiButton from "components/SuiButton";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";

import ButtonGroup from "@mui/material/ButtonGroup";

import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import ManageSearchIcon from "@mui/icons-material/ManageSearch";
import NoteAddIcon from "@mui/icons-material/NoteAdd";
import SearchIcon from "@mui/icons-material/Search";

import { capitalCase } from "capital-case";
import { AccountContext } from "context/account";
import CategoryContext from "context/category-context";
import MyProjectsContext from "context/my-projects";

import Prompt from "components/UpStyled/Prompt";
import toast from "react-hot-toast";
import moment from "moment";
import qs from "query-string";
import { useForm, Controller } from "react-hook-form";
import { DatePicker, Empty } from "antd";

import { filterParser, sortParser } from "utils/helper";
import { projectSortOptions, projectStatusOptions, budgetOptions } from "utils/data";
import ProjectCard4 from "components/UpStyled/project-card/ProjectCard4";

const sortKeys = ["init", "requested", "active", "completed", "canceled"];
const sortKeys_reverse = ["canceled", "completed", "active", "requested", "init"];

const ImportProjectModal = React.forwardRef(
  (
    {
      visible,
      handleClose,
      handleOk,
      isEdit = false,
      categoryTree = [],
      collection,
      handleRefresh = () => {},
      selectedItems = [],
      stage = "all",
    },
    ref
  ) => {
    const [page, setPage] = useState(1);
    const [pageSize, setPageSize] = useState(20);
    const [searchStr, setSearchStr] = useState("");
    const [orderOpt, setOrderOpt] = useState(projectSortOptions[3]);

    const [filterObj, setFilterObj] = useState({});
    const [checked, setChecked] = useState({});
    const [projectList, setProjectList] = useState([]);
    const [filteredProjectList, setFilteredProjectList] = useState([]);
    const [totalNumber, setTotalNumber] = useState(0);

    const [selectedProjects, setSelectedProjects] = useState([]);
    const [selectedStatus, setSelectedStatus] = useState([]);

    useImperativeHandle(
      ref,
      () => ({
        selectedProjects,
        setSelectedProjects,
      }),
      [selectedProjects]
    );

    const {
      register,
      handleSubmit,
      trigger,
      setValue,
      watch,
      getValues,
      reset,
      formState: { errors },
      control,
    } = useForm();

    const { stagesProjects, prospects, removeMyFavoriteProject, addUnFavoriteProject } =
      useContext(MyProjectsContext);

    useEffect(() => {
      if (visible) {
        let temp = {};
        for (let i = 0; i < selectedItems.length; i++) {
          temp[selectedItems[i]?.id] = true;
        }
        setSelectedProjects(selectedItems);
        setChecked(temp);
      }
    }, [visible]);

    useEffect(() => {
      if (visible) {
        retrieveProjects(stage);
      }
    }, [visible]);

    const retrieveProjects = async (stage) => {
      let projects = [];
      if (stage == "prospects") {
        projects = prospects;
      } else {
        projects = stagesProjects[stage] || [];
      }
      const totalNumber = projects.length;
      setTotalNumber(totalNumber);

      const sortedProjects = sortByProjectStatus(projects, sortKeys);

      setProjectList(sortedProjects);
      //filter based on pagination
      const sliceStart = pageSize * (page - 1);
      const sliceEnd = pageSize * page > totalNumber ? totalNumber : pageSize * page;
      const newFilteredList = sortedProjects.slice(sliceStart, sliceEnd);
      setFilteredProjectList(newFilteredList);
    };

    const handleFilterProjectStatus = (
      page,
      pageSize,
      str = searchStr,
      mySelectedStatus = null
    ) => {
      let copyProjects = [...projectList];
      if (mySelectedStatus) {
        if (mySelectedStatus.length > 0) {
          copyProjects = copyProjects.filter((x) => mySelectedStatus.includes(x.status));
        }
      } else {
        if (selectedStatus.length > 0) {
          copyProjects = copyProjects.filter((x) => selectedStatus.includes(x.status));
        }
      }
      let filteredList = copyProjects.map((x) => {
        let StatusOpt = projectStatusOptions.find((opt) => x.status == opt.value);
        return { ...x, statusLabel: StatusOpt?.label ? StatusOpt.label : x.status };
      }); //all projects

      if (str) {
        const strUpper = str.toUpperCase();
        const searchFields = ["name", "description", "statusLabel"];
        filteredList = filteredList.filter((x) => {
          let result = false;
          for (let i = 0; i < searchFields.length; i++) {
            if (x[searchFields[i]]) {
              if (typeof x[searchFields[i]] == "string") {
                if (x[searchFields[i]].toUpperCase().includes(strUpper)) {
                  result = true;
                }
              } else if (typeof x[searchFields[i]] == "object") {
                const text = JSON.stringify(x[searchFields[i]]);
                if (text.toUpperCase().includes(strUpper)) {
                  result = true;
                }
              }
            }
          }
          return result;
        });
      }
      const totalNumber = filteredList.length;
      setTotalNumber(totalNumber);

      //filter based on pagination
      const sliceStart = pageSize * (page - 1);
      const sliceEnd = pageSize * page > totalNumber ? totalNumber : pageSize * page;
      const newFilteredList = filteredList.slice(sliceStart, sliceEnd);
      setFilteredProjectList(newFilteredList);
    };

    const handleChangePage = (event, newPage) => {
      setPage(newPage);
      handleFilterProjectStatus(newPage, pageSize, searchStr);
    };

    const handleChangeRowsPerPage = (option) => {
      const newPageSize = parseInt(option.value, 10);
      setPageSize(newPageSize);
      setPage(1);
      handleFilterProjectStatus(1, newPageSize, searchStr);
    };

    const pageCount = parseInt(Math.ceil(totalNumber / pageSize), 10);
    const pageOptions = [];
    for (let i = 0; i < pageCount; i++) {
      pageOptions.push(i);
    }
    const entriesStart = pageSize * (page - 1) + 1;
    const entriesEnd = pageSize * page > totalNumber ? totalNumber : pageSize * page;

    const handleSearchChange = (str) => {
      setSearchStr(str);
      handleFilterProjectStatus(page, pageSize, str);
    };

    const handleOnSortChange = (e) => {
      setOrderOpt(e);
      let sortStr = e?.value;

      let sortedProjects = [];
      //project status:init,requested,active,completed,canceled=>draft/pending/ongoing/completed/canceled
      //we should sort them by this order instead of alphabet order
      if (sortStr == "status") {
        sortedProjects = sortByProjectStatus(projectList, sortKeys);
      } else if (sortStr == "-status") {
        sortedProjects = sortByProjectStatus(projectList, sortKeys_reverse);
      } else {
        sortedProjects = projectList.sort((a, b) => compare(a, b, sortStr));
      }

      const newFilteredList = sortedProjects.slice(0, pageSize);
      setPage(1);
      setFilteredProjectList(newFilteredList);
    };

    const sortByProjectStatus = (projectList, sortKeys) => {
      let newList = [];
      for (let i = 0; i < sortKeys.length; i++) {
        for (let j = 0; j < projectList.length; j++) {
          if (projectList[j].status == sortKeys[i]) {
            newList.push(projectList[j]);
          }
        }
      }
      return newList;
    };

    const handleCheckProject = (p) => {
      if (checked[p.id] == true) {
        // product was already in the list, then uncheck it
        const newSelectedProjects = selectedProjects.filter((x) => x.id != p.id);
        setSelectedProjects(newSelectedProjects);
      } else {
        setSelectedProjects([...selectedProjects, p]);
      }
      let temp = { ...checked };
      temp[p.id] = !checked[p.id];
      setChecked(temp);
    };

    const handleChangeProjectStatus = (e) => {
      const selectedValue = e?.target?.value || "";
      if (selectedValue && selectedStatus.includes(selectedValue)) {
        let newSelectedStatus = selectedStatus.filter((x) => x != selectedValue);
        setSelectedStatus(newSelectedStatus);
        handleFilterProjectStatus(1, pageSize, searchStr, newSelectedStatus);
      } else if (selectedValue && !selectedStatus.includes(selectedValue)) {
        let newSelectedStatus = [...selectedStatus, selectedValue];
        setSelectedStatus(newSelectedStatus);
        handleFilterProjectStatus(1, pageSize, searchStr, newSelectedStatus);
      }
      setPage(1);
    };

    return (
      <Dialog
        open={visible}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        maxWidth="lg"
        fullWidth={true}
      >
        <DialogTitle id="alert-dialog-title">
          Import your projects{" "}
          <IconButton
            aria-label="close"
            onClick={() => handleClose()}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>

        <DialogContent>
          <SuiBox display="flex" alignItems="center" justifyContent="space-between" gap={1}>
            <SuiBox display="flex" alignItems="center" gap={1}>
              <SuiTypography variant="button" color="dark" fontWeight="regular">
                Filter by:
              </SuiTypography>
              <SuiBox>
                <SuiBox>
                  {stage != "prospects" ? (
                    <SuiBox>
                      <ButtonGroup
                        variant="outlined"
                        aria-label="text button group"
                        color="dark"
                        onClick={handleChangeProjectStatus}
                      >
                        {projectStatusOptions.map((x) => (
                          <SuiButton
                            variant={selectedStatus.includes(x.value) ? "contained" : "outlined"}
                            value={x.value}
                            color={selectedStatus.includes(x.value) ? "info" : "dark"}
                            size="small"
                            sx={{ px: 1, fontSize: 11 }}
                          >
                            {x.label}({stagesProjects[x.value] ? stagesProjects[x.value].length : 0}
                            )
                          </SuiButton>
                        ))}
                      </ButtonGroup>
                    </SuiBox>
                  ) : (
                    <SuiBox />
                  )}
                </SuiBox>
              </SuiBox>
            </SuiBox>
            <SuiBox display="flex" alignItems="center" gap={1}>
              <SuiBox>
                <Card sx={{ borderRadius: 2, maxWidth: 145 }}>
                  <SuiSelect
                    options={projectSortOptions}
                    placeholder="Sort"
                    onChange={handleOnSortChange}
                    value={orderOpt}
                  />
                </Card>
              </SuiBox>
              <SuiBox>
                <SuiInput
                  placeholder="Search Keywords"
                  type="text"
                  onChange={(e) => handleSearchChange(e?.target?.value)}
                  icon={{
                    direction: "right",
                    component: (
                      <SearchIcon
                        sx={{ cursor: "pointer" }}
                        onClick={() => handleSearchChange(searchStr)}
                      />
                    ),
                  }}
                />
              </SuiBox>
            </SuiBox>
          </SuiBox>
          <SuiBox>
            <SuiBox
              display="flex"
              justifyContent="flex-start"
              sx={{ flexWrap: "wrap", minHeight: 200 }}
            >
              <Grid container spacing={2}>
                {filteredProjectList && filteredProjectList.length > 0 ? (
                  filteredProjectList.map((x, index) => (
                    <Grid item md={3}>
                      <ProjectCard4
                        project={x}
                        product={x?.products || []}
                        size="sm"
                        key={index}
                        noSlider={true}
                        isSelected={checked[x.id] ? true : false}
                        handleSelectStyle={(e) => handleCheckProject(x)}
                      />{" "}
                    </Grid>
                  ))
                ) : (
                  <Grid item md={12}>
                    <Empty />
                  </Grid>
                )}
              </Grid>
            </SuiBox>
            <SuiBox
              display="flex"
              flexDirection={{ xs: "column", sm: "row" }}
              justifyContent="space-between"
              alignItems={{ xs: "flex-start", sm: "center" }}
              p={3}
            >
              <SuiBox display="flex" alignItems="center">
                <SuiBox mb={{ xs: 3, sm: 0 }}>
                  <SuiTypography variant="button" color="secondary" fontWeight="regular">
                    Showing {entriesStart} to {entriesEnd} of {totalNumber} entries
                  </SuiTypography>
                </SuiBox>

                <SuiBox display="flex" alignItems="center" gap={1}>
                  <SuiSelect
                    defaultValue={{ value: pageSize, label: pageSize }}
                    options={[10, 20, 50].map((entry) => ({ value: entry, label: entry }))}
                    onChange={handleChangeRowsPerPage}
                    size="small"
                  />

                  <SuiTypography variant="caption" color="secondary">
                    entries per page
                  </SuiTypography>
                </SuiBox>
              </SuiBox>
              <Pagination
                variant={"outlined"}
                color={"info"}
                count={pageOptions.length}
                defaultPage={page}
                onChange={handleChangePage}
              />
            </SuiBox>
          </SuiBox>
        </DialogContent>
        <DialogActions>
          <SuiButton variant="gradient" size="medium" onClick={handleClose} color="light">
            Cancel
          </SuiButton>
          <SuiButton
            size="medium"
            variant="gradient"
            color="dark"
            onClick={handleOk ? () => handleOk(selectedProjects) : null}
          >
            Import
          </SuiButton>
        </DialogActions>
      </Dialog>
    );
  }
);

export default ImportProjectModal;
